import * as types from '../constants/ActionTypes.js'
import { combineReducers } from 'redux'

const initReceiptState = {
  lines: [],
  receiptnumber: null,
  isrefund: false,
  iscreated: false,
  fetchreceiptnumber: false,
  objectitemid: 0,
  objectitemdescription: '',
  objectitemname: null,
  combinedobjectitems: null,
  pricelistid: 0,
  customer: {
    customerid: 0,
    customerName: '',
    customerSaldo: 0,
    lastAction: undefined,
    allowAfterPay: false,
    age: null,
    customerGroupId: 0,
    invoiceOnly: false,
    discountPercentage: 0
  },
  cardname: '',
  paymentdevice: {
    paymentid: 0,
    paymentAmount: 0,
    receiptAmount: 0,
    busy: false,
    status: '',
    oldbalance: 0,
    newbalance: 0
  },
  orderNumber: null,
  pagerNumber: null,
  shouldinvoice: false,
  invoiceReference: '',
  reservationId: null,
  previousLines: null,
  cancelOnAbort: false,

  // This a temporary default change id, it is different from the one that is stored in through the general reducer.
  // This stored in case some payed with fastpay with an default change id, this should be stored here.
  defaultChangeId: 0
}

const initInputState = {
  inputquantity: '0',
  inputquantitydecimal: false,
  inputquantitynegative: false
}

function input(state = initInputState, action) {
  switch (action.type) {
    case types.CLEAR_STATE:
    case types.EMPTY_RECEIPT:
      return Object.assign({}, initInputState, {});
    case types.INPUT_QUANTITY:
      return Object.assign({}, state, { inputquantity: action.quantity });
    case types.INPUT_QUANTITY_DECIMAL:
      return Object.assign({}, state, { inputquantitydecimal: action.inputQuantityDecimal });
    case types.INPUT_QUANTITY_NEGATIVE:
      return Object.assign({}, state, { inputquantitynegative: action.inputquantitynegative });
    default:
      return state;
  }
}

function receipt(state = initReceiptState, action) {
  switch (action.type) {
    case types.SET_RECEIPT_NUMBER:
      return Object.assign({}, state, {
        receiptnumber: action.receiptnumber,
        isrefund: action.refundReceipt,
        iscreated: true
      })
    case types.FETCH_RECEIPT_NUMBER:
      return Object.assign({}, state, {
        fetchreceiptnumber: action.fetchreceiptnumber
      })
    case types.CANCEL_RECEIPT:
      return Object.assign({}, state.receipt, {
        lines: []
      })
    case types.EMPTY_RECEIPT: {
      return {
        ...initReceiptState,
        customer: action.cancel ? state.customer : { ...initReceiptState.customer },
        cardname: action.cancel ? state.cardname : ''
      }
    }
    case types.SET_RESERVATION_FOR_RECEIPT:
      {
        return {
          ...state,
          reservationId: action.reservationId
        }
      }
    case types.UPDATE_RECEIPTLINES:
      return Object.assign({}, state, {
        lines: action.lines
      });
    case types.REMOVE_LAST_ORDER:
      if (state.previousLines) {
        return {
          ...state,
          lines: [...state.previousLines],
        } 
      }
      else {
        return state;
      }
    case types.SET_RECEIPT_OBJECT_ITEM_ID:
      return Object.assign({}, state, {
        objectitemid: action.objectitemid,
        objectitemdescription: action.objectitemdescription
      });
    case types.OPEN_RECEIPT:
      return {
        ...state,
        receiptnumber: action.receiptnumber,
        isrefund: action.isrefund,
        objectitemid: action.objectitemid,
        objectitemname: action.objectitemname,
        combinedobjectitems: action.combinedobjectitems,
        shouldinvoice: action.shouldinvoice,
        invoiceReference: action.invoiceReference,
		    previousLines: action.previousLines.map(line => ({...line}))
      };
    case types.SET_CANCEL_ON_ABORT:
      return {
        ...state,
        cancelOnAbort: true
      }
    case types.SET_RECEIPT_OBJECT_ITEM_NAME:
      return Object.assign({}, state, {
        objectitemname: action.objectitemname
      });
    case types.CLEAR_STATE:
      return Object.assign({}, initReceiptState, {});
    case types.SET_PRICELIST:
      return Object.assign({}, state, {
        pricelistid: action.pricelistid
      })
    case types.SET_PAYMENTDEVICE:
      return Object.assign({}, state, {
        paymentdevice: {
          paymentid: action.paymentid,
          paymentAmount: action.paymentAmount,
          receiptAmount: action.receiptAmount,
          busy: action.busy,
          status: action.status,
          oldbalance: action.oldbalance,
          newbalance: action.newbalance
        }
      });
    case types.SET_CUSTOMER:
      return Object.assign({}, state, {
        customer: {
          customerid: action.customerId,
          customerName: action.name,
          customerSaldo: action.saldo,
          lastAction: action.lastAction,
          allowAfterPay: action.allowAfterPay,
          age: action.age,
          customerGroupId: action.customerGroupId,
          customerGroup: action.customerGroup,
          invoiceOnly: action.invoiceOnly,
          discountPercentage: action.discountPercentage
        },
        age: action.age
      });
    case types.CLEAR_CUSTOMER:
      return {
        ...state,
        customer: { ...initReceiptState.customer },
        shouldinvoice: false,
        invoiceReference: ''
      }
    case types.SET_AGE:
      return Object.assign({}, state, {
        age: action.age
      });
    case types.SET_ARTICLE:
      return Object.assign({}, state, {
        article: {
          articleId: action.articleId,
          articleNumber: action.articleNumber,
          description: action.description
        }
      });
    case types.REGISTER_CUSTOMER_ACTION:
      if (state.customer && state.customer.customerId > 0) {
        return Object.assign({}, state, {
          customer: {
            ...state.customer,
            lastAction: new Date()
          }
        });
      }
      else {
        return state;
      }    
    case types.SET_CARDNAME:
      return Object.assign({}, state, {
        cardname: action.cardname
      });
    case types.SET_ORDERNUMBER:
      return Object.assign({}, state, {
        orderNumber: action.orderNumber
      });
    case types.SET_PAGERNUMBER:
      return Object.assign({}, state, {
        pagerNumber: action.pagerNumber
      });
    case types.SET_SHOULD_INVOICE:
      return Object.assign({}, state, {
        shouldinvoice: action.shouldInvoice,
        invoiceReference: ''
      });
    case types.SET_INVOICE_REFERENCE:
      return Object.assign({}, state, {
        invoiceReference: action.invoiceReference 
      });
    case types.SET_TEMP_DEFAULT_CHANGE_ID: 
      return Object.assign({}, state, {
        defaultChangeId: action.defaultChangeId
      });
    case types.DISABLE_EDIT_BLACK_BOX_LINES:
      return Object.assign({}, state, {
        lines:  state.lines.map((line) => {
          return {
            ...line,
            blackBox_disable_edit: true
          }
        })
      });
    default:
      return state;
  }
}

export const receiptReducer = combineReducers({
  receipt,
  input
})



// WEBPACK FOOTER //
// src/reducers/receipt.js